const hasVisibleRichTextContent = (html?: string | null): boolean => {
  if (!html?.trim()) return false;

  const container = document.createElement('div');
  container.innerHTML = html;

  return (container.textContent ?? '').trim().length > 0;
};

export default hasVisibleRichTextContent;
